import React from 'react';

import { SelectPicker } from 'components/Select';

import './index.css';

export default ({ value, data, error, onSubmit, onClose }: any) => {
  return (
    <SelectPicker
      value={value}
      data={data}
      error={error}
      title={'Manage Columns'}
      multiple={true}
      onSubmit={onSubmit}
      onClose={onClose}
    />
  );
};
